export const MICROPHONE_ERROR_TYPES = {
	PERMISSION_DENIED: "permission_denied",
	NOT_FOUND: "not_found",
	IN_USE: "in_use",
	INSECURE: "insecure",
	UNKNOWN: "unknown",
};

export function resolveMicrophoneAccessError(error) {
	if (!error) return null;

	const name = String(error.name || "");
	const message = String(error.message || "").toLowerCase();

	if (
		name === "NotAllowedError" ||
		name === "PermissionDeniedError" ||
		message.includes("permission denied") ||
		message.includes("not allowed")
	) {
		return {
			type: MICROPHONE_ERROR_TYPES.PERMISSION_DENIED,
			titleKey: "messagesInput.micPermissionDeniedTitle",
			messageKey: "messagesInput.micPermissionDenied",
			hintKey: "messagesInput.micPermissionDeniedHint",
		};
	}

	if (
		name === "NotFoundError" ||
		name === "DevicesNotFoundError" ||
		message.includes("requested device not found")
	) {
		return {
			type: MICROPHONE_ERROR_TYPES.NOT_FOUND,
			titleKey: "messagesInput.micNotFoundTitle",
			messageKey: "messagesInput.micNotFound",
		};
	}

	if (
		name === "NotReadableError" ||
		message.includes("could not start audio source") ||
		message.includes("device in use")
	) {
		return {
			type: MICROPHONE_ERROR_TYPES.IN_USE,
			titleKey: "messagesInput.micInUseTitle",
			messageKey: "messagesInput.micInUse",
		};
	}

	if (name === "SecurityError" || message.includes("secure origin")) {
		return {
			type: MICROPHONE_ERROR_TYPES.INSECURE,
			titleKey: "messagesInput.micInsecureTitle",
			messageKey: "messagesInput.micInsecure",
		};
	}

	return {
		type: MICROPHONE_ERROR_TYPES.UNKNOWN,
		titleKey: "messagesInput.micUnknownTitle",
		messageKey: "messagesInput.micUnknown",
	};
}
